import React, { useState } from 'react';
import { Send, Mail, User, MessageSquare } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';

const ContactFormModal = ({ isOpen, onClose, title = 'Get Started with Guardifix' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Please fill in all fields');
      return;
    }

    // Mock submission
    toast.success("Thank you! We'll be in touch shortly.");
    setFormData({ name: '', email: '', message: '' });
    onClose();
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg" data-testid="contact-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {title}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-5 mt-4" data-testid="contact-form">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-slate-600 mb-2 flex items-center gap-2">
              <User className="h-4 w-4 text-blue-700" />
              Full Name
            </label>
            <Input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              placeholder="Jane Smith"
              className="w-full"
              data-testid="contact-name-input"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-slate-600 mb-2 flex items-center gap-2">
              <Mail className="h-4 w-4 text-blue-700" />
              Email Address
            </label>
            <Input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="jane@company.com"
              className="w-full"
              data-testid="contact-email-input"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-sm font-medium text-slate-600 mb-2 flex items-center gap-2">
              <MessageSquare className="h-4 w-4 text-blue-700" />
              Message
            </label>
            <Textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us about your team's email security requirements..."
              rows={4}
              className="w-full"
              data-testid="contact-message-input"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button
              type="submit"
              data-testid="contact-submit-btn"
              className="flex-1 bg-blue-700 hover:bg-blue-800 text-white rounded-lg"
            >
              <Send className="h-4 w-4 mr-2" />
              Submit
            </Button>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
              data-testid="contact-cancel-btn"
            >
              Cancel
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ContactFormModal;
